import withTransformDeviceTypeProducts from "@utils/withTransformDeviceTypeProducts"
import withTransformMenuData from "@utils/withTransformMenuData"
import Products from "@views/Products"
import { graphql } from "gatsby"
import { compose } from "recompose"

export const query: any = graphql`
  query ProductsByDeviceType($deviceTypeSlug: String) {
    contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
      ...GlobalSettingsCollectionFields
    }

    allContentfulProduct {
      nodes {
        ...ProductDataFields
      }
    }

    contentfulDeviceType(slug: { eq: $deviceTypeSlug }) {
      collectionFooter {
        id
        __typename
        content {
          raw
          references {
            ... on ContentfulAsset {
              contentful_id
              id
              __typename
              title
              description
              file {
                url
              }
            }
          }
        }
        h3Color
        h4Color
        h6Color
        minimalPadding
        padLeft
        padRight
        topPadding
        topPaddingMobile
        bottomPadding
        bottomPaddingMobile
      }
      collectionBannerType
      bannerImage {
        file {
          url
        }
      }
      mobileBannerImage {
        file {
          url
        }
      }
      bannerHeader
      bannerSubheader {
        bannerSubheader
      }
      paragraphHeader
      paragraphBody {
        paragraphBody
      }
      paragraphAsymmetricalSplit
    }
  }
`

export default compose(
  withTransformDeviceTypeProducts,
  withTransformMenuData
)(Products)
